module.exports = __webpack_public_path__ + "img/arrow_right_blue.121a7c1c.svg";